/**
 * Chat content the client offers as buttons (P2-RT-09): quick messages and reactions travel as
 * ordinary `chat.send` text, and the room tells them apart only for analytics (`chat_message_sent`
 * kind; never the content). Placeholder wording for the beta, easy to change: the room accepts any
 * text, and an old client's list is still just text.
 */
export const QUICK_MESSAGES = [
  "Nice!",
  "Help!",
  "Over here!",
  "On my way",
  "Thanks!",
  "Good game",
] as const;

export const REACTIONS = ["👍", "😂", "😮", "❤️", "🎉"] as const;

export type ChatKind = "text" | "quick" | "reaction";

/** What kind of message a text is, for `chat_message_sent`. */
export function chatKind(text: string): ChatKind {
  if ((REACTIONS as readonly string[]).includes(text)) return "reaction";
  if ((QUICK_MESSAGES as readonly string[]).includes(text)) return "quick";
  return "text";
}
